<template>
  <div class="StatusItem">
    <span
      v-if="status === userStatus.active"
      class="StatusItem__inner StatusItem__inner--active"
      title="アクティブ"
      >アクティブ</span
    >
    <span
      v-else-if="status === userStatus.invited"
      class="StatusItem__inner StatusItem__inner--inviting"
      title="招待中"
    >
      招待中<Tooltip
        v-if="mailResendNeeded"
        class="StatusItem__tooltip"
        text="招待メール再送"
        size="100"
        ><button
          v-if="mailResendNeeded"
          class="StatusItem__button"
          aria-label="招待メール再送"
          @click="onClickSend"
        >
          <Icon
            v-if="mailResendNeeded"
            class="StatusItem__icon"
            iconName="Send"
          /></button
      ></Tooltip>
    </span>
    <span
      v-else-if="status === userStatus.expired"
      class="StatusItem__inner StatusItem__inner--expired"
      title="期限切れ"
    >
      期限切れ<Tooltip
        v-if="mailResendNeeded"
        class="StatusItem__tooltip"
        text="招待メール再送"
        size="100"
        ><button
          v-if="mailResendNeeded"
          class="StatusItem__button"
          aria-label="招待メール再送"
          @click="onClickSend"
        >
          <Icon
            v-if="mailResendNeeded"
            class="StatusItem__icon"
            iconName="Send"
          /></button
      ></Tooltip>
    </span>
  </div>
</template>

<script lang="ts">
export default {
  name: 'StatusItemItem',
};
</script>

<script lang="ts" setup>
import Icon from '@spectee/components/Atoms/IconBase/index.vue';
import Tooltip from '@spectee/components/Atoms/Tooltip/index.vue';
// import Feedback from '@spectee/components/Molecules/Feedback/index.vue';
import { userStatus, UserStatus } from '@spectee/ts/userStatus';

type Props = {
  status: UserStatus;
  mailResendNeeded: boolean;
};

const props = withDefaults(defineProps<Props>(), { mailResendNeeded: true });

const emit = defineEmits(['onClick']);

const onClickSend = () => {
  emit('onClick');
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.StatusItem {
  &__inner {
    position: relative;
    display: flex;
    align-items: center;
    // padding-left: $service-unit * 3;
    font-size: $service-font-size-p;

    // &::before {
    //   position: absolute;
    //   left: 0;
    //   display: inline-block;
    //   width: $service-unit * 2;
    //   height: $service-unit * 2;
    //   content: '';
    //   border-radius: 50%;
    // }

    &--active {
      color: $color-green-60;
    }

    &--inviting {
      color: $color-brown-60;
    }

    &--expired {
      color: $color-red-60;
    }
  }

  & &__tooltip {
    height: $service-unit * 6;
    margin-left: $service-unit * 2;
  }

  &__button {
    width: $service-unit * 6;
    height: $service-unit * 6;
    cursor: pointer;
    background-color: transparent;
    border-radius: 50%;

    &:hover {
      background-color: $color-gray-20;
    }
  }
}
</style>
